// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --bg: #ebe3d5;
  --gold: #b8a562;
  --green: #82938c;
  --dark: #302631;
  --text-light: #666;
  --border: #d4c9b8;
  --shadow: rgba(0, 0, 0, 0.1);
  --success: #4CAF50;
  --error: #f44336;
  --font-display: 'Barriecito', cursive;
  --font-body: 'Kode Mono', monospace;
}

body {
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg);
  color: var(--dark);
}

button {
  cursor: pointer;
  border: none;
  font-family: inherit;
}

input,
textarea,
select {
  font-family: inherit;
}

a {
  text-decoration: none;
  color: inherit;
}

img {
  max-width: 100%;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --bg: #ebe3d5;\n  --gold: #b8a562;\n  --green: #82938c;\n  --dark: #302631;\n  --text-light: #666;\n  --border: #d4c9b8;\n  --shadow: rgba(0, 0, 0, 0.1);\n  --success: #4CAF50;\n  --error: #f44336;\n  --font-display: 'Barriecito', cursive;\n  --font-body: 'Kode Mono', monospace;\n}\n\nbody {\n  font-family: var(--font-body);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg);\n  color: var(--dark);\n}\n\nbutton {\n  cursor: pointer;\n  border: none;\n  font-family: inherit;\n}\n\ninput,\ntextarea,\nselect {\n  font-family: inherit;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
